import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { BasisAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/basis/basis-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const BasisAccessRulesConst: Record<BasisAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль BASIS (Базовый) ---
  // --- Раздел BASIS.SECTIONS.SAVED_FILTER (Сохраненные фильтры) ---
  [BasisAccessRulesKeyEnum.BASIS_SAVED_FILTER_READ]: {
    $and: [
      {
        'BASIS.enabled': true
      },
      {
        $or: [
          {
            'FINANCE.enabled': true,
            'BRS.sections.BRS.tabs.DDS.accessLevel': { $gte: AccessLevelEnum.READ }
          },
          {
            'FINANCE.enabled': true,
            'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
          },
          {
            'FINANCE.enabled': true,
            'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.enabled': true,
            'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.accessLevel': { $gte: AccessLevelEnum.READ }
          },
          {
            'FINANCE.enabled': true,
            'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': { $gte: AccessLevelEnum.READ }
          }
        ]
      }
    ]
  },

  // --- Раздел BASIS.SECTIONS.COMPANY (Компании) ---
  [BasisAccessRulesKeyEnum.BASIS_COMPANY_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.COMPANY.tabs.COMPANY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_COMPANY_GROUP_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.COMPANY.tabs.COMPANY_GROUP.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_COMPANY_ERP_1C_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.COMPANY.tabs.ERP_1C.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_COMPANY_ACCESS_TO_ALL_COMPANIES]: {
    'BASIS.enabled': true,
    'BASIS.sections.COMPANY.permissions.ACCESS_TO_ALL_COMPANIES.isAllowed': true
  },

  // --- Раздел BASIS.SECTIONS.CLIENT (Клиенты) ---
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.tabs.CLIENT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_CONTRAGENT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.tabs.CONTRAGENT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_CONTRACT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.tabs.CONTRACT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_EXTERNAL_USER_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.tabs.EXTERNAL_USER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_BANNER_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.tabs.BANNER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CLIENT_CAN_DELETE_CLIENTS]: {
    'BASIS.enabled': true,
    'BASIS.sections.CLIENT.permissions.CAN_DELETE_CLIENTS.isAllowed': true
  },

  // --- Раздел BASIS.SECTIONS.SECURITY (Пользователи) ---
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_GROUP_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.GROUP.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_GROUP_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.GROUP.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_ROLE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.ROLE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_ROLE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.ROLE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.USER.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.USER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_UNREAD_REPORT_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.UNREAD_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_UNREAD_REPORT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.UNREAD_REPORT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_WORK_SCHEDULE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.WORK_SCHEDULE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_WORK_SCHEDULE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.WORK_SCHEDULE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_CAN_BAN_USER]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.permissions.CAN_BAN_USER.isAllowed': true
  },

  [BasisAccessRulesKeyEnum.BASIS_SECURITY_USER_ACCESS_TO_LIST]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.USER.permissions.ACCESS_TO_LIST.isAllowed': true
  },
  [BasisAccessRulesKeyEnum.BASIS_SECURITY_GROUP_ACCESS_TO_LIST]: {
    'BASIS.enabled': true,
    'BASIS.sections.SECURITY.tabs.GROUP.permissions.ACCESS_TO_LIST.isAllowed': true
  },

  // --- Раздел BASIS.SECTIONS.CATALOG (Справочники) ---
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DIRECTION_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DIRECTION.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DIRECTION_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DIRECTION.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_UNIT_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.UNIT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_UNIT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.UNIT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_FILIAL_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.FILIAL.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_FILIAL_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.FILIAL.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_ROOM_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.ROOM.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_ROOM_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.ROOM.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_TYPE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DOCUMENT_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_TYPE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DOCUMENT_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_OPERATION_TYPE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.OPERATION_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_OPERATION_TYPE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.OPERATION_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_MASTER_MILESTONE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.MASTER_MILESTONE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_MASTER_MILESTONE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.MASTER_MILESTONE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_APPROVAL_SCHEME_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.APPROVAL_SCHEME.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_APPROVAL_SCHEME_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.APPROVAL_SCHEME.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_NOMENCLATURE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.NOMENCLATURE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_NOMENCLATURE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.NOMENCLATURE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_COST_CENTER_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.COST_CENTER.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_COST_CENTER_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.COST_CENTER.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_ACCOUNTING_ACCOUNT_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.ACCOUNTING_ACCOUNT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_ACCOUNTING_ACCOUNT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.ACCOUNTING_ACCOUNT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_AI_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.AI.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_AI_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.AI.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_WEBHOOK_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.WEBHOOK.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_WEBHOOK_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.WEBHOOK.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DOCUMENT_FILE_TEMPLATE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_DOCUMENT_FILE_TEMPLATE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.DOCUMENT_FILE_TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_EAV_ENTITY_TYPE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.EAV_ENTITY_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_EAV_ENTITY_TYPE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.EAV_ENTITY_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Permissions
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_APPROVAL_SCHEME_ACCESS_ALL]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.permissions.ACCESS_TO_ALL_APPROVAL_SCHEMES.isAllowed': true
  },
  [BasisAccessRulesKeyEnum.BASIS_CATALOG_ACCESS_TO_ALL_DIRECTIONS]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.permissions.ACCESS_TO_ALL_DIRECTIONS.isAllowed': true
  },

  // --- Раздел BASIS.SECTIONS.SYSTEM (Админ панель) ---
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_BUDGET_CLASSIFICATION_CODE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.BUDGET_CLASSIFICATION_CODE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_CHANGELOG_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.CHANGELOG.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_CURRENCY_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.CURRENCY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_PAYER_STATUS_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.PAYER_STATUS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_PLUGIN_1C_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.PLUGIN_1C.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_RATE_PLAN_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.RATE_PLAN.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [BasisAccessRulesKeyEnum.BASIS_SYSTEM_TENANT_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.SYSTEM.tabs.TENANT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // --- Раздел BASIS.SECTIONS.DASHBOARD (Рабочий стол) ---
  [BasisAccessRulesKeyEnum.BASIS_DASHBOARD_TEMPLATE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.DASHBOARD.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Виджеты
  [BasisAccessRulesKeyEnum.BASIS_DASHBOARD_ACCOUNTS_CASHES_MONEY_WIDGETS]: {
    $and: [
      {
        'BASIS.enabled': true
      },
      {
        $or: [
          {
            'BASIS.sections.DASHBOARD.tabs.ACCOUNTS_MONEY.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          },
          {
            'BASIS.sections.DASHBOARD.tabs.CASHES_MONEY.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          }
        ]
      }
    ]
  },
  [BasisAccessRulesKeyEnum.BASIS_DASHBOARD_PROFIT_AND_LOSS_WIDGETS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BUDGET_REQUEST.accessLevel': { $gte: AccessLevelEnum.READ },
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': { $gte: AccessLevelEnum.READ },
    'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [BasisAccessRulesKeyEnum.BASIS_DASHBOARD_SAVED_FILTER_FINANCE_WIDGETS]: {
    $and: [
      {
        'BASIS.enabled': true
      },
      {
        $or: [
          {
            'FINANCE.enabled': true
          },
          {
            'BRS.enabled': true
          }
        ]
      },
      {
        $or: [
          {
            'BRS.sections.BRS.tabs.DDS.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          },
          {
            'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          },
          {
            'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.enabled': true,
            'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          },
          {
            'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': {
              $gte: AccessLevelEnum.READ
            }
          }
        ]
      }
    ]
  },
  [BasisAccessRulesKeyEnum.BASIS_DASHBOARD_OVERSPENDING_WIDGET]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': { $gte: AccessLevelEnum.READ },
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': { $gte: AccessLevelEnum.READ },
    'FINANCE.sections.PLAN_FACT.tabs.BUDGET_REQUEST.accessLevel': { $gte: AccessLevelEnum.READ }
  }
};
